import { createAtomObserver } from '@exodus/atoms'

const ordersLifecyclePlugin = ({ orders, port, ordersAtom, ordersMonitor }) => {
  const atomObserver = createAtomObserver({ atom: ordersAtom, port, event: 'orders' })

  const onStart = () => {
    orders.load()
  }

  const onLoad = () => {
    atomObserver.start()
  }

  const onUnlock = () => {
    ordersMonitor.tick()
  }

  const onClear = () => ordersAtom.set(undefined)

  const onStop = () => orders.stop()

  return { onClear, onLoad, onStart, onStop, onUnlock }
}

const ordersLifecyclePluginDefinition = {
  id: 'ordersLifecyclePlugin',
  type: 'plugin',
  factory: ordersLifecyclePlugin,
  dependencies: ['orders', 'port', 'ordersAtom', 'ordersMonitor'],
  public: true,
}

export default ordersLifecyclePluginDefinition
